import type { ListProjectRequests } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import apiClient from "@/lib/api/client";

export function useResolveRequests(projectIds: number[] | undefined) {
  return useQuery({
    enabled: projectIds && projectIds.length > 0,
    queryFn: () =>
      apiClient
        .url("/users/resolve-requests")
        .post({ projectIds })
        .json<ListProjectRequests>(),
    queryKey: ["user-resolve-requests", projectIds],
  });
}
